import { render, staticRenderFns } from "./EditarLicenciasCliente.vue?vue&type=template&id=37595464&scoped=true"
import script from "./EditarLicenciasCliente.vue?vue&type=script&lang=js"
export * from "./EditarLicenciasCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37595464",
  null
  
)

export default component.exports